import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "custom-select links" }
const _hoisted_2 = {
  key: 0,
  class: "body-text"
}
const _hoisted_3 = { class: "text" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "arrows" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow" }),
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-select-arrow" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "select-selected filter-arrows",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSorting && _ctx.toggleSorting(...args)))
    }, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.name) + " (" + _toDisplayString(_ctx.currentType) + ")", 1),
      _hoisted_4
    ])
  ]))
}